import React from 'react';
import { useSelector } from 'react-redux';

const useStyles = () => ({
  container: {
    display: 'flex',
    width: '70%',
  },
});

const StatsHeaderDesktop = () => {
  const styles = useStyles();
  const selection = useSelector((state) => state.mainControls.selection);
  const headerLabel = selection ? `${selection.level}:` : 'Massachusetts';
  const headerValue = selection ? selection.name : '';

  return (
    <div id="selected-feature-details-header" style={styles.container}>
      <div style={{ fontSize: '16px' }}>{headerLabel}</div> <div> &nbsp;{headerValue}</div>
    </div>
  );
};

export default StatsHeaderDesktop;
